import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Auth } from 'aws-amplify';
import { dateFormat, 
         PARTICIPANTS_EPISODE_DETAIL_URL, 
         ADD_PARTICIPANT_FORM_URL
        } from '../../../constants';
import { renderCellExpand } from '../../common/GridCell/GridCellExpand';
import { getStopApi } from '../../../services/StopApi/StopApi';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { getAddParticipantFormSlice } from '../../../redux/participant/AddParticipant/addParticipantSliceForm';
import ParticipantDialog from '../../Participant/ParticipantDialog';

const EpisodeParticipant = (props) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [episodeParticipant, setEpisodeParticipant] = useState({
    isLoading: false,
    data: [],
    pageSize: 100,
    total: 0,
    page: 1,
  });
  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );
  //const episodeParticipantData = useSelector(
  //  (state) => state?.episodeParticipantData
  //);
  const participantInfo = useSelector(
    (state) => state?.participants?.participantsDetail
  );
  //useEffect(() => {
  //  console.log('### participantInfo changed');
  //  console.log(participantInfo);
  //  fetchEpisodeParticipantData();
  //}, [participantInfo])


  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken && participantInfo) {
      fetchEpisodeParticipantData();
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken, participantInfo]);

  //useEffect(() => {
  //  if (episodeParticipantData?.refreshEpisodeParticipant) {
  //    console.log('### DO REFRESH')
  //    fetchEpisodeParticipantData();
  //  }
  //}, [episodeParticipantData?.refreshEpisodeParticipant]);

  const fetchEpisodeParticipantData = async () => {
    //console.log('### FETCH EPISODE PARTICIPANT DATA:');
    //console.log('### episodeId:');
    //console.log(episodeId);
    //console.log('### participantInfo:');
    //console.log(participantInfo);
    //console.log(episodeParticipantData);
    setEpisodeParticipant((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${PARTICIPANTS_EPISODE_DETAIL_URL}${participantInfo[0].id}/episodes?PageNumber=${episodeParticipant.page}&PageSize=${episodeParticipant.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      const jsonData = json?.filter((item) =>
        item.episodeID === episodeId ? item.episodeID : ''
      );
      //console.log('### fetchEpisodeParticipantData');
      //console.log(jsonData[0]);
      setEpisodeParticipant((prveState) => ({
        ...prveState,
        isLoading: false,
        data: [
          {
            _id: 0,
            key: participantInfo[0].key,
            id: participantInfo[0].id,
            dateOfBirth: participantInfo[0].dateOfBirth ? moment(participantInfo[0].dateOfBirth).format(
              dateFormat
            ): '-',
            gender: participantInfo[0].gender?.value || participantInfo[0].gender,
            registration290: participantInfo[0].registration290,
            arsonist: participantInfo[0]?.arsonist,
            cCCMS: jsonData[0]?.cCCMS,
            cDCNumber: jsonData[0]?.cDCNumber,
            expectedEPRD: jsonData[0]?.expectedEPRD
              ? moment(jsonData[0]?.expectedEPRD)
                  .format(dateFormat)
                  .split('T')[0]
              : '-',
            reg: jsonData[0]?.reg,
            paroleCounty:
              jsonData[0]?.paroleCounty === null
                ? '-'
                : jsonData[0]?.paroleCounty.value,
            episodeSAPStartDate: jsonData[0]?.episodeSAPStartDate
              ? moment(jsonData[0]?.episodeSAPStartDate)
                  .format(dateFormat)
                  .split('T')[0]
              : '-',
            episodeDischargeDate: jsonData[0]?.episodeDischargeDate
              ? moment(jsonData[0]?.episodeDischargeDate)
                  .format(dateFormat)
                  .split('T')[0]
              : '-',
            referralSource: jsonData[0]?.referralSource.value,
            caseManager: jsonData[0]?.caseManager,
          },
        ],
      }));
    }).catch((e) => alert(e));
  };

  const updateParticipantDialog = (params) => {
    const url = `${ADD_PARTICIPANT_FORM_URL}/participants/${params.row.id}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 700);
    dispatch(getAddParticipantFormSlice({ url, authorization }));
    setOpen(true);
  };

  const columnsData = [
    { field: '_id', hide: true },
    {
      field: 'actions',
      headerName: 'Actions',
      cellClassName: 'participant-header',
      //type: 'actions',
      renderCell: (params) => {
        return (
          <IconButton onClick={() => updateParticipantDialog(params)}>
            <EditIcon />
          </IconButton>
        );
      },
    },
    {
      field: 'key',
      headerName: 'Participant',
      minWidth: 200,
      sortable: false,
      cellClassName: 'participant-header'
    },
    {
      field: 'cDCNumber',
      headerName: 'CDC#',
      minWidth: 100,
      sortable: false,
      cellClassName: 'participant-header'
    },
    //{
    //  field: 'id',
    //  headerName: 'Prt Id',
    //  minWidth: 60,
    //  flex: 1,
    //  sortable: false,
    //},
    {
      field: 'dateOfBirth',
      headerName: 'DOB',
      type: 'date',
      minWidth: 90,
      flex: 1,
      sortable: false,
      cellClassName: 'participant-header'
    },
    {
      field: 'gender',
      headerName: 'Gender',
      flex: 1,
      sortable: false,
      cellClassName: 'participant-header'
    },
    {
      field: 'registration290',
      headerName: '290',
      flex: 1,
      sortable: false,
      type: 'boolean',
      cellClassName: 'participant-header'
    },
    {
      field: 'arsonist',
      headerName: 'Arsonist',
      flex: 1,
      sortable: false,
      type: 'boolean',
      cellClassName: 'participant-header'
    },
    {
      field: 'cCCMS',
      headerName: 'CCC MS',
      flex: 1,
      type: 'boolean',
      sortable: false,
      cellClassName: 'participant-header'
    },
    {
      field: 'expectedEPRD',
      headerName: 'EPRD',
      type: 'date',
      minWidth: 100,
      flex: 1,
      sortable: false,
      cellClassName: 'participant-header'
    },
    {
      field: 'reg',
      headerName: 'Parole Region',
      flex: 1,
      sortable: false,
      cellClassName: 'participant-header'
    },
    {
      field: 'paroleCounty',
      headerName: 'Parole County',
      renderCell: renderCellExpand,
      flex: 1,
      sortable: false,
      cellClassName: 'participant-header'
    },
    {
      field: 'episodeSAPStartDate',
      headerName: 'Episode Start Date',
      type: 'date',
      minWidth: 100,
      flex: 1,
      cellClassName: 'participant-header'
    },
    {
      field: 'episodeDischargeDate',
      headerName: 'Episode Discharge Date',
      type: 'date',
      minWidth: 100,
      flex: 1,
      cellClassName: 'participant-header'
    },
    {
      field: 'referralSource',
      headerName: 'Referral SAP',
      renderCell: renderCellExpand,
      flex: 1,
      sortable: false,
      cellClassName: 'participant-header'
    },
    {
      field: 'caseManager',
      headerName: 'Case Manager',
      renderCell: renderCellExpand,
      minWidth: 200,
      flex: 1,
      sortable: false,
      cellClassName: 'participant-header'
    },
  ];

  return (
    <>
    <div style={{ height: 120, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataGrid
              //rowHeight = {52}
              //autoHeight
              hideFooter
              //getRowHeight={() => 'auto'}
              //getRowId={(row) => row._id}
              columns={columnsData}
              rows={episodeParticipant.data}
              //loading={episodeParticipant.isLoading}
              disableColumnFilter
              disableColumnMenu
            />
          </div>
        </div>
      </div>      
      <ParticipantDialog
          open={open}
          setOpen={setOpen}
          openBackdrop={openBackdrop}
          fetchData={fetchEpisodeParticipantData}
          authToken={user?.signInUserSession.accessToken.jwtToken}
      />
    </>
  );
};

export default EpisodeParticipant;
